import { FC } from "react";
import { useTranslation } from "react-i18next";
import { discountFromCoupon } from "~/utils/couponCalculations";
import { referAFriendMockCoupon } from "../constants";
import { DiscountLine } from "./DiscountLine";

interface Props {
  fullPrice: number;
}

export const ReferAFriendDiscount: FC<Props> = ({ fullPrice }) => {
  const { t } = useTranslation();

  const discountAmount = discountFromCoupon(fullPrice, referAFriendMockCoupon);

  return (
    <DiscountLine
      description={t("planPayment.promoCode.referAFriend")}
      discountAmount={discountAmount}
    />
  );
};
